import { useEffect } from "react";

export const useDocumentContextMenuDefaultPrevented = (exceptionsSelector?: string) => {
  useEffect(() => {
    const handleContextMenu = (event: MouseEvent) => {
      if (exceptionsSelector) {
        const target = event.target as Element;
        if (target.closest(exceptionsSelector)) {
          return;
        }
      }
      event.preventDefault();
      event.stopPropagation();
    };

    document.addEventListener('contextmenu', handleContextMenu);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, [exceptionsSelector]);
};
